// disable no-invalid-getInitialProps
import PropTypes from 'prop-types';
import Error from '@comp/Error/Error';

import { captureException } from '@utils/sentry';
import Layout from '@layout/SimpleLayout/SimpleLayout';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const ErrorComponent = ({ statusCode }) => <Error statusCode={statusCode} />;

ErrorComponent.pageInfo = {
  isMWebSupported: true
};

ErrorComponent.getInitialProps = async ({ req, res, err }) => {
  const statusCode = res?.statusCode;

  if (statusCode === 404) {
    captureException(err, req, statusCode);
    return { statusCode: 404 };
  }
  if (err) {
    captureException(err, req, statusCode);
    return err;
  }

  captureException(err, req, statusCode);

  return { statusCode: 500 };
};

ErrorComponent.propTypes = {
  statusCode: PropTypes.number
};

ErrorComponent.defaultProps = {
  statusCode: 404
};

export default ErrorComponent;
ErrorComponent.Layout = Layout;
ErrorComponent.Wrapper = PageReduxProvider;
